import React, { Component } from "react";
import logo from "../../image/owner2_logo.png"
import "tachyons"
import { getFromStorage } from "../../utils/storage";
import { getOwnerLogo } from "./logoImages";

class Navbar extends Component {
	constructor(props) {
	super(props);
    	this.state = {
      	owner_logo: ""
    	};
    }
    
    componentDidMount(){
        console.log("owner_id:");
        console.log(getFromStorage("owner_id"));
        getOwnerLogo(getFromStorage("owner_id")).then(res => this.setState({owner_logo: "data:image/png;base64,"+res})).catch(err => console.log(err));
        // this.setState({owner_logo:"data:image/png;base64,R0lGODlhAQABAIAAAP7//wAAACH5BAAAAAAALAAAAAABAAEAAAICRAEAOw=="});
    }


  render() {
    return (
      <div className="navbar shadow-4" style={{zIndex: 50}}>
        <img src={logo} style={{width: "60px", height: "60px", right: "2%", position: "absolute"}} alt="logo"/>
        <img src={this.state.owner_logo} style={{width: "60px", height: "60px", left: "2%", position: "absolute"}} alt="owner_logo"/>
        <h4
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            fontWeight: "bold"
          }}
          align="center"
        >
         {getFromStorage("dashboard_name")} Dashboard
        </h4>
        <h6
          style={{
            marginLeft: "auto",
            marginRight: "auto",
            fontWeight: "bold",
            right:"1%",
            color:"Green"
             }}
            align="right"
            >
            Semion Limited Helpline : 01558243103 , 01845554988
          </h6>
      </div>
    );
  }
}

export default Navbar;
